import React from "react";
//import Carousel from "../components/Carousel";
//import ExpertiseSection from "../components/ExpertiseSection";
import AboutUs from "../components/AboutUs";
import HeroSection from "../components/HeroSection";
import UnigsSection from "../components/UnigsSection";
import JoinUsSection from "../components/JoinUsSection";
import WhyUs from "../components/WhyUs";
import Header from "../components/Header";
//import ATMASSection from "../components/ATMASSection";
import PrivacyPolicy from "../components/PrivacyPolicy";
import TermsOfService from "../components/TermsOfService";
import OurServicesAndSolutions from "../components/OurServicesAndSolutions";
import ContactUs from "../components/ContactUs";


const Home = () => {
    /*const firstCarouselSlides = [
    {
    text: "Welcome to INBI NextGen Innovations Private Limited",
    headline: "Inventions Beyond the Imagination ",
    imgSrc: "heroimg.jpg",
    //text: "At INBI NextGen Innovations, we’re not just developers or engineers. We're dreamers, inventors, and pioneers pushing the boundaries of what's conceivable in the worlds of software and hardware automation.",
    imgAlt: "Cloud Integration",
    },
    
    ];*/

const homeNavLinks = [
    {label:"Home",href:"#home"},
    { label: "Services", href: "#services" },
    {label:"Unigs",href:"#unigs"},
    { label: "About Us", href: "#about" },
    { label: "Why Us", href: "#why-us" },
    { label: "Contact Us", href: "#contact-us" },
];

    return (
        <div>
        <Header navLinks={homeNavLinks} />
        <HeroSection/>
        {/* <Carousel slides={firstCarouselSlides} />*/}
        <OurServicesAndSolutions/>
        <UnigsSection /> 
        <AboutUs />
          
        <WhyUs />
        <ContactUs />

        </div>
    );
};
export default Home;
